import { render, staticRenderFns } from "./AddFieldsBoard.vue?vue&type=template&id=5048b7ce&"
import script from "./AddFieldsBoard.vue?vue&type=script&lang=ts&"
export * from "./AddFieldsBoard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports